// Action types for fetching orders
export const SYNC_ORDER_REQUEST = 'SYNC_ORDER_REQUEST';
export const SYNC_ORDER_SUCCESS = 'SYNC_ORDER_SUCCESS';
export const SYNC_ORDER_FAILURE = 'SYNC_ORDER_FAILURE';
export const SYNC_ORDER_REST = 'SYNC_ORDER_REST';
// Fetch data actions
export const syncStoreOrderRequest = (payload) => ({
    type: SYNC_ORDER_REQUEST,
    payload,
});
export const syncStoreOrderSuccess = (payload) => ({
    type: SYNC_ORDER_SUCCESS,
    payload,
});
export const syncStoreOrderFailure = (error) => ({
    type: SYNC_ORDER_FAILURE,
    payload: error,
});
export const syncStoreOrderRest = () => ({
    type: SYNC_ORDER_REST,
});
